import { request } from "utils/request";
import { AxiosPromise } from "axios";

export const areaApi = {
  findAll: (params?: any): AxiosPromise<any> =>
    request({
      url: "/v1/shop/area",
      params,
    }),
  create: (data: any): AxiosPromise<any> =>
    request({
      url: "/v1/shop/area",
      data,
      method: "post",
    }),
  update: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: `/v1/shop/area/${id}`,
      method: "patch",
      data,
    }),
  delete: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/shop/area/${id}`,
      method: "delete",
    }),
};
